module.exports = __webpack_public_path__ + "img/Feature.b87a7321.jpg";